<script setup lang="ts">
import { MtdSpinner, MtdTypography } from '@paygine/mtd-uikit'
</script>

<template>
    <div class="loading">
        <MtdSpinner class="loading__spinner" />

        <MtdTypography
            variant="header-6"
            class="loading__title"
            tag="h1"
            >Обрабатываем запрос
        </MtdTypography>

        <MtdTypography
            tag="p"
            variant="textbody-2"
            class="loading__subtitle"
            >Пожалуйста, подождите</MtdTypography
        >
    </div>
</template>

<style scoped lang="scss">
.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 36px 16px 40px;
    gap: 16px;

    &__spinner {
        height: 90px;
        width: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 4px;
    }
}
</style>
